import React from 'react';
import PricingPageTableHeader from './PricingPageTableHeader';
import useStyles from './styles';
import IntroButton from '../IntroButton';

const TrialPricingPageTableHeader = () => {
  const classes = useStyles();

  return (
    <PricingPageTableHeader>
      <div className={classes.title}>Intro</div>
      <div className={classes.description}>
        For those who want evaluate PitchHub's® video creation and editing services or occasionally make videos
      </div>
      <div className={classes.planTitle}>
        Pay as you go
      </div>
      <div className={classes.planDescription}>
        Pay for each video you produce as you go
      </div>

      <IntroButton />
    </PricingPageTableHeader>
  );
};

export default TrialPricingPageTableHeader;
